import React from 'react';
import { FaEye } from 'react-icons/fa';
import { X } from 'lucide-react';
import FileUpload from './FileUpload';
import { useThemeStore } from '../../state/theme';
import { Resource } from '../../hooks/useResourceUpload';

interface ResourceUploadSectionProps {
  title: string;
  category: string;
  resources: Resource[];
  onFilesChange: (files: File[], category: string) => Promise<void>;
  onRemoveResource: (index: number, category: string) => void;
  onViewResource: (resource: Resource) => Promise<void>;
  isUploading: boolean;
  accept?: string;
  maxSize?: number;
  maxFiles?: number;
}

const ResourceUploadSection: React.FC<ResourceUploadSectionProps> = ({
  title,
  category,
  resources,
  onFilesChange,
  onRemoveResource,
  onViewResource,
  isUploading,
  accept = '.pdf,.doc,.docx,.txt',
  maxSize = 100,
  maxFiles = 10,
}) => {
  const { isDarkMode } = useThemeStore();

  return (
    <div>
      <FileUpload
        title={title}
        files={[]}
        onFilesChange={(files) => onFilesChange(files, category)}
        accept={accept}
        maxSize={maxSize}
        maxFiles={maxFiles}
        isUploading={isUploading}
      />

      {resources.length > 0 && (
        <div className="space-y-2 my-4">
          {resources.map((resource, index) => (
            <div
              key={index}
              className={`flex items-center justify-between p-3 rounded-lg border ${
                isDarkMode
                  ? 'bg-gray-700 border-gray-600'
                  : 'bg-gray-50 border-gray-200'
              }`}
            >
              <span
                className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}
              >
                {resource.originalName || `File ${index + 1}`}
              </span>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => onViewResource(resource)}
                  className="text-blue-500 hover:text-blue-700 p-1"
                >
                  <FaEye size={16} />
                </button>
                <button
                  type="button"
                  onClick={() => onRemoveResource(index, category)}
                  className="text-red-500 hover:text-red-700 p-1"
                >
                  <X size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResourceUploadSection;